module.exports = __webpack_public_path__ + "static/media/arrow_down_Gray.00b86808.svg";